import { http } from 'src/services/numbers/http'
import {
  IAvailableNumber,
  PlaceVariables,
} from 'src/store/modules/numbers/types'

export interface IGetAvailableNumbersParams {
  perPage?: number
  phoneNumberFilterType?: PlaceVariables
  phoneNumberFilterValue?: string
}

export interface IGetAvailableNumbers {
  data: IAvailableNumber[]
}

export interface IDeleteAccount {
  accountIds: number[]
}

export interface IAssigneRcNumber {
  phoneNumber: string
}

export const getAvailableNumbersTwillio = ({
  perPage = 20,
  ...params
}: IGetAvailableNumbersParams) =>
  http.get<IGetAvailableNumbers>(`/numbers/available`, {
    params: { ...params, perPage },
  })

export const getAvailableNumbersRc = () =>
  http.get<IGetAvailableNumbers>(`/ring-central/numbers`)

export interface IAssigneNumberParams {
  communicationNumber: number
}

export const assigneRcNumber = (params: IAssigneRcNumber) =>
  http.put(`/ring-central/account`, params)

export const releaseNumber = (params: IDeleteAccount) =>
  http.delete(`accounts`, { params })

export const assigneTwillioNumber = ({
  communicationNumber,
}: IAssigneNumberParams) => http.post(`/numbers/assign/${communicationNumber}`)
